var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,23c-3,0-5.5-2.5-5.5-5.5V5c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4v10.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5V6h2 v9.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V5c0-1.1-0.9-2-2-2S9,3.9,9,5v12.5c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5V6h2v11.5 C18,20.5,15.5,23,12.5,23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.b697b8560c7dfcd47c2bbb1e7ebe9cc6.svg";
export { ForwardRef as ReactComponent };